export default __webpack_public_path__ + "static/media/twitter.4ac181b7.svg";